import React from 'react';
import { Link } from 'react-router-dom';

const MainComponent = () => {
	const now = new Date();
	const month = now.getMonth() + 1 + ''; // '1'
	const dateString = `${now.getFullYear()}년 ${month}월 ${now.getDate()}일`; // '2023년 1월 1일'
	const yyyyMM = `${now.getFullYear()}${month.padStart(2, '0')}`; // '202301'

	return (
		<div className='mbti-wrapper'>
			<div className='part1'>
				<div className='layout'>
					<div className='txt-area'>
						<h2>
							<span className='txt-sub'>비글즈 이벤트 메인</span>
						</h2>
						<div className='txt'>
							<span>{dateString}</span>
						</div>
					</div>
					<div className='btn-area start'>
						<Link to='/mbti' className='on'>
							MBTI 테스트
						</Link>
						<Link to='/tutorial' className='on'>
							튜토리얼
						</Link>
						<Link
							to={`/game-king/rank?date=${yyyyMM}&member_se=21`}
							className='on'
						>
							게임의왕좌 랭킹
						</Link>
						<Link to={`/game-king/promotion/app?date=${yyyyMM}`} className='on'>
							게임의왕좌 프로모션
						</Link>
						<Link
							to={`/game-king/GameKingPrizeWinner`}
							className='on'
						>
							게임의왕좌 당첨자
						</Link>
						<Link to='/roulette/main' className='on'>
							룰렛 메인
						</Link>
						<Link to='/drawlots/main' className='on'>
							뽑기 메인
						</Link>
						<Link to='/bingo/main' className='on'>
							빙고 메인
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MainComponent;
